import errorReporter from '@app/errorReporter';

const DECIMAL = '.';

const TENTH_DIGIT_LENGTH = 2;

const formatCurrency = (
  input: string | number,
  options?: Intl.NumberFormatOptions,
) => {
  if (!input && input !== 0) return undefined;
  const number = typeof input === 'number' ? input : Number(input);

  if (Number.isNaN(number)) {
    const err = new Error(
      `Please provide a valid input to be formatted. Provided input: ${input}, cannot be coerced to number.`,
    );
    errorReporter.error(err);
  }

  const formatted = number?.toLocaleString('en-CA', {
    style: 'currency',
    currency: 'CAD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
    ...options,
  });

  if (
    formatted.length >= TENTH_DIGIT_LENGTH &&
    formatted[formatted.length - TENTH_DIGIT_LENGTH] === DECIMAL
  ) {
    return `${formatted}0`;
  }

  return formatted;
};

export default formatCurrency;
